import React from 'react';
import { Box, TextField, IconButton, Button, Switch, FormControlLabel } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export default function MailToolbar({ q, setQ, unified, setUnified, onRefresh, onCompose }) {
  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', p: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', bgcolor: '#fff', borderRadius: 1, px: 1 }}>
        <SearchIcon sx={{ color: '#6B7280' }} />
        <TextField placeholder="Search" variant="standard" value={q} onChange={e => setQ(e.target.value)} sx={{ ml: 1 }} />
      </Box>
      <FormControlLabel control={<Switch checked={unified} onChange={e => setUnified(e.target.checked)} />} label="Unified Inbox" />
      <Button variant="contained" onClick={onCompose}>Compose</Button>
      <Button onClick={onRefresh}>Refresh</Button>
    </Box>
  );
}
